import { ChangeEvent } from 'react'

import FormElement from '@/components/form'
import HeadingWithIcon from '@/components/heading'
import { FolderIcon } from '@/components/icons/folder'
import { InputFieldSearch } from '@/components/input'
import Block from '@/layouts/block'
import Section from '@/layouts/section'
import { GRID } from '@/lib/constants'
import { ResponsiveTabs } from '@/components/tabs'
import LocationFilter from '@/components/dropdown/location-filter'

interface TabsSectionProps {
  title?: string
  tabsContent: string[]
  activeElementIndex: number
  handleChangeActiveElemIndex: (index: number) => void
  handleInputSearchQueryChange: (e: ChangeEvent<HTMLInputElement>) => void
  searchQuery: string
  handleSubmitSearch: () => void
}

const TabsSection = ({
  tabsContent,
  activeElementIndex,
  handleChangeActiveElemIndex,
  title,
  handleInputSearchQueryChange,
  searchQuery,
  handleSubmitSearch,
}: TabsSectionProps) => {
  return (
    <Section className={`tabsSection ${GRID} p-10 mt-20`}>
      <Block className={`col-span-full col-start-1 lg:col-end-6 w-full`}>
        <HeadingWithIcon
          title={title as string}
          iconComponent={<FolderIcon />}
          isLarge
        />
      </Block>
      <Block className="col-span-full lg:col-start-6 lg:col-end-13 w-full">
        <FormElement
          submitForm={handleSubmitSearch}
          initialValues={{ searchQuery: '' }}
        >
          <InputFieldSearch
            onChange={handleInputSearchQueryChange}
            name="search"
            value={searchQuery}
            placeholder="Zoek een verhaal..."
            type="text"
            loading={false}
          />
        </FormElement>
      </Block>
      <ResponsiveTabs
        content={tabsContent}
        activeElementIndex={activeElementIndex}
        handleChangeActiveElemIndex={handleChangeActiveElemIndex}
      />
    </Section>
  )
}

export default TabsSection

interface ExtendedTabsSectionProps extends TabsSectionProps {
  locations: string[]
  handleChangeLocation: (e: ChangeEvent<HTMLInputElement>) => void
}

export const TabsSectionWithFilterAndSearch = ({
  tabsContent,
  activeElementIndex,
  handleChangeActiveElemIndex,
  title,
  handleInputSearchQueryChange,
  searchQuery,
  handleSubmitSearch,
  locations,
  handleChangeLocation,
}: ExtendedTabsSectionProps) => {
  return (
    <Section className={`tabsSection ${GRID} p-10 mt-20`}>
      <Block className={`col-span-full col-start-1 lg:col-end-6 w-full`}>
        <HeadingWithIcon
          title={title as string}
          iconComponent={<FolderIcon />}
          isLarge
        />
      </Block>
      <Block className="col-span-full lg:col-start-6 lg:col-end-13 w-full">
        <FormElement
          submitForm={handleSubmitSearch}
          initialValues={{ searchQuery: '' }}
        >
          <InputFieldSearch
            onChange={handleInputSearchQueryChange}
            name="search"
            value={searchQuery}
            placeholder="Zoek in trainingen & events…"
            type="text"
            loading={false}
          />
        </FormElement>
      </Block>
      <ResponsiveTabs
        content={tabsContent}
        activeElementIndex={activeElementIndex}
        handleChangeActiveElemIndex={handleChangeActiveElemIndex}
      />
      <LocationFilter
        locations={locations}
        handleChangeLocation={handleChangeLocation}
      />
    </Section>
  )
}
